import React, { useState } from "react";
import styles from "../../styles/Sidebar.module.scss";
import Link from "next/link";
import { onSignOut } from "../../views/auth/fetchers/auth";
import { useRouter } from "next/router";
import { MenuItem } from "../../layout/PrimaryLayout";

interface OwnProps {
  menu: MenuItem[];
}
type Props = OwnProps;

interface Button {
  active: boolean;
  children: any;
}

const Button = (props: Button) => (
  <a
    className={styles.button + (props.active ? " " + styles.activebutton : "")}
    {...props}
  >
    {props.children}
  </a>
);

const Accordion: React.FC<{
  data: any;
  accordion_id: string;
  is_empower?: boolean;
}> = ({ data, accordion_id, is_empower }) => {
  const router = useRouter();
  const shouldBeOpened = (links: any = []) => {
    return links.some((link) => router.asPath.includes(link.link));
  };
  const [isOpened, setOpened] = useState<boolean>(
    data && data.links ? shouldBeOpened(data.links) : false
  );
  const [openedSubAccordion, setOpenedSubAccordion] = useState<string | null>(
    null
  );

  return (
    <div className={styles.accordion} key={accordion_id}>
      <div
        className={
          (is_empower ? styles.multiaccordion : styles.accordiontitle) +
          (isOpened ? " " + styles.accordionactivetitle : "")
        }
        onClick={() => setOpened(!isOpened)}
      >
        <div>
          <div className={styles.accordionicon}>
            <img src={"/public-new/navigation/" + data.icon + ".svg"} alt="" />
          </div>
          <div>{data.title}</div>
        </div>
        <img
          className={styles.arrow}
          src={"/public-new/arrow-down.svg"}
          alt=""
        />
      </div>
      {isOpened && (
        <div className={styles.menu}>
          {data.links.map((link, index) => (
            <React.Fragment key={`${accordion_id}-link-${index}`}>
              {link.multi ? (
                <>
                  <div
                    className={
                      styles.accordiontitle +
                      (openedSubAccordion === `accordion-${index}`
                        ? " " + styles.accordionactivetitle
                        : "")
                    }
                    onClick={() =>
                      openedSubAccordion === `accordion-${index}`
                        ? setOpenedSubAccordion(null)
                        : setOpenedSubAccordion(`accordion-${index}`)
                    }
                  >
                    <div className={styles.submenutitle}> {link.title}</div>
                    <img
                      className={styles.arrow}
                      src={"/public-new/arrow-down.svg"}
                      alt=""
                    />
                  </div>
                  {openedSubAccordion === `accordion-${index}` && (
                    <div className={styles.submenu}>
                      {link.multiGuide &&
                        link.multiGuide.map((data, subIndex) => (
                          <Accordion
                            is_empower={true}
                            key={`accordion-${index}-sub-${subIndex}`}
                            accordion_id={`accordion-${index}-sub-${subIndex}`}
                            data={data}
                          />
                        ))}
                      {link.subLinks.map((link) => (
                        <>
                          <div key={link.link + link.title}>
                            <Link passHref href={link.link}>
                              <Button
                                active={
                                  router.asPath.includes(link.link) ||
                                  router.asPath.includes(link.baseLink)
                                }
                              >
                                {link.title}
                              </Button>
                            </Link>
                          </div>
                        </>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div
                  key={`${accordion_id}-link-${index}`}
                  style={{ paddingLeft: "13px" }}
                >
                  <Link passHref href={link.link}>
                    <a
                      target={!link.relative ? "_blank" : "_self"}
                      rel={!link.relative ? "noopener noreferrer" : undefined}
                    >
                      <Button
                        active={
                          router.asPath.includes(link.link) ||
                          router.asPath.includes(link.baseLink)
                        }
                      >
                        {link.title}
                      </Button>
                    </a>
                  </Link>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

const GuideSidebar: React.FC<Props> = (props) => {
  const router = useRouter();

  return (
    <div className={styles.sidebar}>
      <div className={styles.body}>
        <Link passHref href={"/"}>
          <div>
            <img className={styles.logo} src={"/public-new/logo.svg"} alt="" />
          </div>
        </Link>
        {props.menu?.map((button: MenuItem, index) =>
          button.type === "link" ? (
            <Link key={`accordion-link-${index}`} passHref href={button.link}>
              <div
                className={
                  styles.menulink +
                  (router.pathname === button.link
                    ? " " + styles.activemenulink
                    : "")
                }
              >
                <div className={styles.menulinktitle}>
                  <div className={styles.menulinkicon}>
                    <img
                      className={styles.arrow}
                      src={"/public-new/navigation/" + button.icon + ".svg"}
                      alt=""
                    />
                  </div>
                  <div>{button.title}</div>
                </div>
              </div>
            </Link>
          ) : (
            <Accordion
              key={`accordion-${index}`}
              accordion_id={`accordion-${index}`}
              data={button}
            />
          )
        )}
      </div>
      <div className={styles.bottommenu}>
        <div className={styles.logout} onClick={async () => await onSignOut()}>
          <img alt="Log Out" src={"/public-new/logout.svg"} />
          <div>Logout</div>
        </div>
      </div>
    </div>
  );
};

export default GuideSidebar;
